const b2cZh = {
  zh: {
    myPlan: {
      title: '我的計劃',
      product_category: '種類',
      product_name: '產品',
      policy_status: '保單狀態',
      policy_no: '申請/保單號碼',
    },
    myProfile: {
      title: '我的個人資料',
      name: '客戶名稱',
      phone_number: '聯絡電話',
      email: '電郵',
      res_address: '戶籍地',
      corr_address: '通信地址',
      for_company_only: '以下資料僅供高富金融集團紀錄之用',
      need_to_update_personal_info: '如欲更改以上資料，請電郵到 ',
      for_enquiry: '如有任何疑問，請聯絡您的客戶經理或',
      enquiry_link: '按此',
    },
    messageBox: {
      title: '留言框',
      subTitle: '項目',
      type: '種類',
      policy_no: '保單號碼',
    },
    planDetail: {
      title: '我的計劃',
      overview: '計劃概述',
      details: '計劃明細',
      form_download: '表格下載',
      form_download_title: '項目',
      form_download_link: '連結',
      form_download_original: '須正本',
      form_download_copy: '接受傳真',
      auto_translate_remark_1: '',
      auto_translate_remark_2: '',
    },
    statements: {
      monthly_statement: '投資組合報告',
      provider_statement: 'Statement From',
      policy_owner: '保單持有人',
      address: '地址',
      contact_no: '聯絡電話',
      email: '電郵',
      print_out_date: '對帳單印發日',
      policy_no: '保單號碼',
      plan_start_date: '計劃生效日',
      plan_term: '計劃年期',
      payment_freq: '供款頻率',
      pay_term: '供款年期',
      payment_method: '供款方法',
      policy_status: '保單狀態',
      payment_status: '供款狀態',
      portfolio_type: '投資組合顧問服務類別',
      policy_plan_Name: '計劃名稱',
      joint_policy_Owner: '聯名申請人',
      name_of_insured: '被保人姓名',
      name_of_beneficiary: '受益人姓名',
      modal_premium: '每期保費',
      modal_premium_for_insurance: '每期保費',
      total_premium_paid: '總供款額',
      estimated_premium_and_levy_amount: '預計應繳保費及保費徵費金額',
      next_contribute_due_date: '保費到期日',
      pending_transaction_amount: '交易中暫計款',
      withdrawal_amount: '提領金額',
      sum_insured: '保險金額 / 名義金額',
      account_holder: '帳戶持有人',
      account_no: '帳戶號碼',
      ac_opening_date: '帳戶開始日',
      account_type: '帳戶類別',
      joint_account_holder: '聯名持有人',
      report_currency: '報表幣別',
      holding_type_I: '首初帳戶',
      holding_type_A: '累積帳戶',
      holding_type_C: '目前持有',
      fund_code: '基金編號',
      fund_name: '基金名稱',
      unit_balance: '單位數',
      fund_currency: '基金幣別',
      unit_price: '單位價格',
      valuation_date: '估值日',
      in_fund_currency: '基金幣別計價',
      in_plan_currency: '保單幣別計價',
      sub_total: '小計',
      i_sub_total: '小計',
      a_sub_total: '小計',
      total_portfolio_value: '總投資組合帳戶價值',
      total_portfolio_value_in_valuation_currency: '估值幣別等值帳戶價值',
      plan_type: '計劃種類',
      plan_name: '計畫名稱',
      total: '總額',
      available_balance: '可用餘額（報表幣別）',
      cash_balance: '現金餘額',
      currency_type: '幣別種類',
      exch_rate: '兌匯率',
      in_original_currency: '原始幣別',
      in_report_currency: '報表幣別',
      contribution_allocation: '分配比率',
      portfolio_breakdown: '投資組合明細',
      allocation_percentage: '分配比率',
      portfolio_percentage: '投資組合比率',
      asset_class: '資產類別',
      disclaimer_1:
        '受限於轉換中之基金交易及尚在處理中之基金交易無法報價，上述的帳戶價值可能無法完全反映出整體的帳戶價值；因此，請於上述交易完成後再次確認您的帳戶價值。',
      disclaimer_2:
        '請注意，基金的單位價格及投資收入有高有低，過去的績效亦不代表未來績效之保證。投資人於投資申購前應詳閱基金公開說明書及其他相關資訊。',
      disclaimer_3:
        '如發現對帳單上資料不正確或有錯誤，請立即通知我們（{{companyName}}）處理。',
      disclaimer_4:
        '**所有的帳戶價值及匯率換算僅供參考使用。客戶詳盡的帳戶價值、持有單位數請參閱產品公司的月/季/半年報。',
      disclaimer_5:
        '請注意，投資組合顧問費之收取會直接以客戶帳戶內之單位數扣抵，並不會有其他另外的收費方式產生。',
      metis_disclaimer_1: '針對每檔基金之詳細配置，請參閱其基金月報。',
      metis_disclaimer_2:
        '基金的單位價格有高有低，過去的績效亦不代表未來績效之保證。投資人於投資申購前應詳閱基金公開說明書及其他相關資訊。',
      metis_disclaimer_3:
        '所有的帳戶價值及匯率換算僅供參考使用。客戶詳盡的帳戶價值、持有單位數請參閱產品公司的月/季/半年報。',
      metis_disclaimer_4:
        '如發現對帳單上資料不正確或有錯誤，請立即通知我們（{{companyName}}）處理。',
      abf_fund_descriptions: 'ABF多元資產策略組合 - 上月底十大持股',
      abf_fund_allocation: '基金配置',
      etf_fund_descriptions: '密諾亞ETF策略基金 - 上月底投資組合明細',
      etf_fund_allocation: '基金配置',
      life_policy_value: '保單價值',
      pd_description: '內容描述',
      life_amount: '金額',
      life_cash_value: '基本保障額之現金價值',
      life_dividend: '累積紅利',
      life_future_deposit: '保費儲備金',
      life_loan_balance: '借貸額',
      life_total_policy_value: '現金總值',
      life_estimated_premium_and_levy_amount: '預計應繳保費及保費徵費金額',
      life_next_contribute_due_on: '保費到期日',
      life_next_due_premium: '每期保費',
      life_accumulated_guaranteed_coupon: '累積的保證現金',
      life_terminal_dividend: '終期紅利',
      life_surrender_value: '退保價值',
      life_vitality_discount: 'Vitality折扣',
      life_premium_refund: '保費回贈',
      life_next_levy: '下期保費徵費',
    },
  },
};

export default b2cZh;
